function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  viewBox: "0 0 23 23"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.429 0c6.311 0 11.428 5.117 11.428 11.429 0 6.311-5.117 11.428-11.428 11.428C5.117 22.857 0 17.74 0 11.43 0 5.117 5.117 0 11.429 0zm0 1.714c-5.365 0-9.715 4.35-9.715 9.715s4.35 9.714 9.715 9.714 9.714-4.35 9.714-9.714c0-5.365-4.35-9.715-9.714-9.715zm0 9.715c2.799 0 4.722 1.224 5.583 3.605a2 2 0 01-1.88 2.68H7.725a2 2 0 01-1.881-2.68c.86-2.381 2.785-3.605 5.584-3.605zm0 1.714c-2.106 0-3.368.803-3.972 2.474a.286.286 0 00.269.383h7.405a.286.286 0 00.27-.383c-.605-1.672-1.867-2.474-3.972-2.474zm0-8.572a3.143 3.143 0 110 6.286 3.143 3.143 0 010-6.286zm0 1.715a1.429 1.429 0 100 2.857 1.429 1.429 0 000-2.857z"
}));